<template>
  <div v-if="checkCreatePermission()">
    <vs-button
      @click="openModalForUpload"
      icon-pack="feather"
      icon="icon-upload-cloud"
      type="flat"
      size=""
      class="w-full"
      >File</vs-button
    >
    <vs-popup
      classContent="popup-example"
      :title="repo_path"
      :active.sync="popupActivo4"
    >
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start">
          <!-- <vs-radio  v-model="changeTheme" vs-value="list">List</vs-radio>&nbsp;
                        <vs-radio v-model="changeTheme" vs-value="grid">Grid</vs-radio> -->
          <vs-button
            v-if="changeTheme === 'grid'"
            color="primary"
            type="filled"
            class="mt-5"
            @click="changeTheme = 'list'"
            >List</vs-button
          >
          <vs-button
            v-if="changeTheme === 'list'"
            color="primary"
            type="filled"
            class="mt-5"
            @click="changeTheme = 'grid'"
            >Grid</vs-button
          >
        </vs-col>
      </vs-row>
      <br />
      <!-- <div class="vx-row">
              <div class="vx-col w-full">

                  <div @dragover.prevent @drop.prevent>

                  <div class="container" @dragleave="fileDragOut" @dragover="fileDragIn" @drop="handleFileDrop">
                    <h6>Location: &nbsp;{{repo_path}}</h6>
                    <br>
                    <div class="file-wrapper">

                      <input  type="file"  ref="fileupload" multiple @change="handleFileInput" > <p v-if="files.length !== 0">You Selected {{files.length}} Files</p>
                      <p v-if="files.length === 0">Click Or Drag Here To Choose</p>
                    </div>
                     <vs-row><vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" >
                      <vs-button
                  color="primary"
                  type="filled"
                  class="w-full mt-5"
                  :disabled="buttonActive"
                  @click="uploadFile"
                >Upload File</vs-button>
              </vs-col></vs-row>
                  </div>
                </div>


              </div>
            </div> -->
      <div class="cstm_vuefileagent_holder">
        <VueFileAgent
          ref="vueFileAgent"
          :theme="changeTheme"
          :multiple="true"
          :deletable="true"
          :meta="true"
          :accept="'image/*,video/*,audio/*,.pdf,.doc,.docx,.xlsx'"
          :maxSize="'10MB'"
          :maxFiles="100"
          :helpText="'Click Or Drag Here To Choose'"
          :errorText="{
            type: 'Only images, audio, video, docs allowed',
            size: 'File should not exceed 10MB in size',
          }"
          @select="filesSelected($event)"
          @beforedelete="onBeforeDelete($event)"
          @delete="fileDeleted($event)"
          v-model="fileRecords"
        ></VueFileAgent>
        <p class="or_text_holder">(or)</p>
        <vs-tooltip
          class="inline-block align-bottom"
          color="primary"
          text="Select files From Gdrive"
        >
          <vs-button
            class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
            color="primary"
            type="border"
            @click="driveIconClicked('Files')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              enable-background="new 0 0 32 32"
              height="32px"
              id="Layer_1"
              version="1.0"
              viewBox="0 0 32 32"
              width="32px"
              xml:space="preserve"
            >
              <g>
                <polyline
                  fill="#537ABD"
                  points="31.868,21 9.868,21 4.868,30 26.556,30  "
                />
                <polyline
                  fill="#2EB672"
                  points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "
                />
                <polyline
                  fill="#FED14B"
                  points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "
                />
              </g>
            </svg>
          </vs-button>
        </vs-tooltip>
      </div>
      <br />
      <vs-row v-if="fileRecordsForUpload.length" vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-start">
          <vs-button
            :disabled="!fileRecordsForUpload.length"
            @click="uploadFiles()"
          >
            Upload {{ fileRecordsForUpload.length }}
            {{ fileRecordsForUpload.length > 1 ? "files" : "file" }}
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { addFile, repoDetails } from '@/api/file.js'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'fileupload',
  props: ['repo_id', 'repo_path', 'filesInfo'],
  mixins: [GoogleAuthorization, PermissionMiddleware],
  data () {
    return {
      file_repository_id: null,
      changeTheme: 'list',
      uploadFilesAll: [],
      popupActivo4: false,
      fileRecords: [],
      uploadUrl: '',
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: []
    }
  },
  created () {
    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
    this.imagevalidation = 'image/*,video/*,audio/*,.pdf,.doc,.docx,.xlsx'
    this.imageHint = 'Click Or Drag Here To Choose'

    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Files')
    }
  },
  methods: {
    openModalForUpload () {
      this.file_repository_id = this.repo_id
      this.popupActivo4 = true
    },
    addedFile (allFile) {
      this.$emit('addedFile', allFile)
    },
    uploadFiles () {
      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {
          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )

      this.$vs.loading({
        type: 'radius',
        text: 'Uploading File! Please Wait'
      })
      data
        .then((response, error) => {
          if (response) {
            const cdn = response[0].data.data.cdn
            for (let i = 0; i < response.length; i++) {
              const file_name = response[i].data.data.files[0].file_name
              const file_path = response[i].data.data.files[0].file_path

              const raw = JSON.stringify({
                file_repository_id: this.repo_id,
                files: [
                  {
                    file_name,
                    file_path: `${cdn}${file_path}`
                  }
                ]
              })

              const uploadedFile = raw

              this.getUploadFiles(uploadedFile)
              this.fetchDetailsFromFolder()
              this.$vs.loading.close()
            }
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []
    },

    // async getUploadFiles (uploadedFile, type = 'system') {
    //   const res = await addFile(uploadedFile)

    //   if ((res.data.message === 'files.createFile')) {
    //     repoDetails(localStorage.getItem('customer_id'), this.repo_id)
    //       .then((res) => {
    //         this.$vs.loading.close()
    //         this.addedFile(res.data.data.repository)
    //         this.$refs.vueFileAgent.value = null
    //         this.fileRecordsForUpload = []
    //         this.fileRecords = []
    //         this.popupActivo4 = false

    //       })
    //       .catch((e) => {

    //         this.$refs.vueFileAgent.value = null
    //         this.fileRecordsForUpload = []
    //         this.fileRecords = []
    //         this.popupActivo4 = false
    //         this.$vs.loading.close()
    //       })

    //   }
    // },
    async getUploadFiles (file_id_payload, type = 'system') {
      const res = await addFile(file_id_payload)

      if (res.data.message === 'files.createFile') {
        const file = {
          file: res.data.data.files[0]
        }
        //this.filesInfo.push(file)
        const filesDriveInfo = res.data.data.files
        let filesDrive = []
        if (type === 'drive') {
          filesDrive = filesDriveInfo.map((ele) => {
            return {
              name: ele.file_name,
              sizeText: this.bytesToSize(ele.size),
              size: ele.size,
              type: ele.file_type,
              url: ele.file_path,
              color: 'green',
              upload: {
                data: true,
                error: false
              }
            }
          })
          this.fileRecords.push(...filesDrive)
        }

        //const file_id = res.data.data.files[0].files_id
      }
    },
    fetchDetailsFromFolder () {
      repoDetails(localStorage.getItem('customer_id'), this.repo_id)
        .then((res) => {
          this.addedFile(res.data.data.repository)
          this.$refs.vueFileAgent.value = null
          this.fileRecordsForUpload = []
          this.fileRecords = []
          this.popupActivo4 = false
        })
        .catch((e) => {
          this.$refs.vueFileAgent.value = null
          this.fileRecordsForUpload = []
          this.fileRecords = []
          this.popupActivo4 = false
        })
    },

    deleteUploadedFile (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      )
    },
    filesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      )
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords)
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else if (confirm('Are you sure you want to delete?')) {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    }

    // addedFile (allFile) {
    //   this.$emit('addedFile', allFile)
    // },
    // onFileSelected (event) {
    //   this.selectedFile = event.target.files
    //   //
    // },
    // handleFileDrop (e) {
    //   let droppedFiles = e.dataTransfer.files
    //   if (!droppedFiles) return;

    //   ([...droppedFiles]).forEach(f => {

    //     this.files.push(f)
    //   })
    //   this.selectedFile = this.files
    //   this.color = '#444444'
    // },
    // handleFileInput (e) {
    //   let files = e.target.files
    //   files = e.target.files
    //   if (!files) return;

    //   ([...files]).forEach(f => {

    //     this.files.push(f)
    //   })
    //   this.selectedFile = this.files
    // },
    // uploadFile () {
    //   // eslint-disable-next-line eqeqeq
    //   if (this.selectedFile != null) {
    //     this.buttonActive = !this.buttonActive
    //     const formData = new FormData()
    //     for (let i in this.selectedFile) {
    //       formData.append(`files[${  i  }]`, this.selectedFile[i])
    //     }
    //     this.$vs.loading({
    //       type: 'radius'
    //     })
    //     uploadFile(localStorage.getItem('customer_id'), formData)
    //       .then((res) => {

    //         this.selectedFiledata.push({
    //           file_repository_id: this.repo_id,
    //           files: res.data.data.files
    //         })
    //
    //         for (let i in this.selectedFiledata[0].files) {

    //
    //           this.selectedFiledata[0].files[i].file_path = res.data.data.cdn + this.selectedFiledata[0].files[i].file_path
    //
    //         }
    //         //
    //         addFile(this.selectedFiledata[0])
    //           .then((res) => {
    //
    //             repoDetails(localStorage.getItem('customer_id'), this.repo_id)
    //               .then((res) => {
    //                 this.$vs.loading.close()
    //                 this.addedFile(res.data.data.repository)
    //                 this.selectedFile = null
    //                 this.selectedFiledata = []
    //                 this.files = []
    //                 this.$refs.fileupload.value = null
    //                 this.popupActivo4 = false
    //                 this.buttonActive = false

    //               })
    //               .catch((e) => {
    //
    //                 this.$vs.loading.close()
    //               })
    //             this.popupActivo4 = false
    //             this.selectedFile = null
    //             this.selectedFiledata = []
    //             this.files = []
    //             this.$refs.fileupload.value = null
    //             this.buttonActive = false
    //             this.$vs.notify({
    //               title: 'Success',
    //               text: 'File uploaded successfully',
    //               color: 'success',
    //               iconPack: 'feather',
    //               icon: 'icon-alert-circle'
    //             })
    //           })
    //           .catch((e) => {
    //
    //             this.$vs.loading.close()
    //             this.popupActivo4 = false
    //             this.selectedFile = null
    //             this.selectedFiledata = []
    //             this.files = []
    //             this.$refs.fileupload.value = null
    //             this.buttonActive = false
    //             this.$vs.notify({
    //               title: 'Warning',
    //               text: 'Something Went Wrong',
    //               color: 'warning',
    //               iconPack: 'feather',
    //               icon: 'icon-alert-circle'
    //             })
    //           })

    //       })
    //       .catch((e) => {
    //
    //         this.$vs.loading.close()
    //         this.popupActivo4 = false
    //         this.selectedFile = null
    //         this.selectedFiledata = []
    //         this.files = []
    //         this.$refs.fileupload.value = null
    //         this.buttonActive = false
    //         this.$vs.notify({
    //           title: 'Warning',
    //           text: 'Something Went Wrong',
    //           color: 'warning',
    //           iconPack: 'feather',
    //           icon: 'icon-alert-circle'
    //         })
    //       })
    //   }
    // },
    // fileDragIn () {
    //   // alert("oof")
    //   // alert("color")
    //   this.color = 'white'
    // },
    // fileDragOut () {
    //   this.color = '#444444'
    // }
  }
}
</script>
<style scoped>
.container {
  padding-right: 0rem;
  padding-left: 0rem;
}

.file-wrapper {
  text-align: center;
  width: 600px;
  height: 5em;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
  background: white; /* and other things to make it pretty */
  border: 2px dashed rgba(var(--vs-primary), 1);
  border-radius: 1rem;
}

.file-wrapper input {
  position: absolute;
  top: 0;
  right: 0; /* not left, because only the right part of the input seems to
                 be clickable in some browser I can't remember */
  cursor: pointer;
  opacity: 0;
  filter: alpha(
    opacity=0
  ); /* and all the other old opacity stuff you
                                 want to support */
  font-size: 300px; /* wtf, but apparently the most reliable way to make
                         a large part of the input clickable in most browsers */
  height: 200px;
}
</style>
